import React, {Component} from 'react';
import {View, Text, TouchableOpacity, ViewProps} from 'react-native';

import Image from '../custom/Image';
import {theme} from '../../constants';
import {ProductType} from '../../types';
// import NewBadge from '../badges/NewBadge';
import {useAppNavigation} from '../../hooks';
import OrderCounter from './OrderCounter';
import DishName from '../product/ProductName';
import ProductPrice from '../product/ProductPrice';
import ImageBackground from '../custom/ImageBackground';
import {hasPositiveWeight, formatCaloriesLabel} from '../../utils/product';

type Props = {
  item: ProductType;
  lastElement?: boolean;
  containerStyle?: object;
};

const OrderItem: React.FC<Props> = ({
  item,
  lastElement,
  containerStyle,
}): JSX.Element => {
  const navigation = useAppNavigation();

  const marginBottom = lastElement ? 30 : 14;

  const renderImage = () => {
    const imageWidth = 94;
    if (item.image) {
      return (
        <Image
          source={{uri: item.image}}
          style={{width: imageWidth, aspectRatio: imageWidth / imageWidth}}
          resizeMode='cover'
        />
      );
    }

    return (
      <View
        style={{
          width: imageWidth,
          aspectRatio: imageWidth / imageWidth,
          borderRadius: 10,
          backgroundColor: '#E9F3F6',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <DishName item={item} />
      </View>
    );
  };

  const renderInfo = () => {
    const hasWeight = hasPositiveWeight(item.weight);
    const caloriesLabel = formatCaloriesLabel(item.calories);
    const hasCalories = typeof caloriesLabel === 'string' && caloriesLabel.length > 0;
    return (
      <View style={{marginLeft: 14, marginRight: 'auto'}}>
        <DishName
          item={item}
          style={{
            marginBottom: 3,
          }}
        />
        {(hasCalories || hasWeight) && (
          <Text
            style={{
              ...theme.fonts.DMSans_400Regular,
              fontSize: 10,
              color: theme.colors.textMuted,
              marginBottom: 14,
            }}
          >
            {hasCalories ? caloriesLabel : ''}
            {hasCalories && hasWeight ? ' - ' : ''}
            {hasWeight ? `${item.weight}` : ''}
          </Text>
        )}
        {Array.isArray(item.selectedAddons) && item.selectedAddons.length > 0 && (
          <View style={{marginBottom: 10}}>
            {item.selectedAddons.map((addon) => {
              const addonKey = `${item.cartItemId ?? item.id}-${addon.addonId}`;
              return (
                <View key={addonKey} style={{marginBottom: 4}}>
                  <Text
                    style={{
                      ...theme.fonts.DMSans_500Medium,
                      fontSize: 10,
                      color: theme.colors.textPrimary,
                    }}
                  >
                    {addon.name}
                  </Text>
                  {addon.options.map((option) => {
                    const optionKey = `${addonKey}-${option.id ?? option.name}`;
                    return (
                      <Text
                        key={optionKey}
                        style={{
                          ...theme.fonts.DMSans_400Regular,
                          fontSize: 10,
                          color: theme.colors.textMuted,
                        }}
                      >
                        {`${option.quantity} x ${option.name}`}
                      </Text>
                    );
                  })}
                </View>
              );
            })}
          </View>
        )}
        <ProductPrice item={item} containerStyle={{marginBottom: 'auto'}} />
      </View>
    );
  };

  // const renderNewBadge = () => {
  //   if (item.is_new) {
  //     return (
  //       <NewBadge
  //         containerStyle={{
  //           padding: 7,
  //           position: 'absolute',
  //           top: 0,
  //           left: 0,
  //           zIndex: 1,
  //         }}
  //       />
  //     );
  //   }

  //   if (!item.is_new) {
  //     return null;
  //   }
  // };

  const renderOrderCounter = () => {
    return <OrderCounter item={item} />;
  };

  const touchableOpacityStyle: object = {
    flexDirection: 'row',
    width: '100%',
    minHeight: 111,
    backgroundColor: theme.colors.backgroundPrimary,
    borderRadius: 10,
    alignItems: 'center',
    paddingVertical: 10,
  };

  return (
    <TouchableOpacity
      style={{...touchableOpacityStyle, ...containerStyle}}
      onPress={() => {
        navigation.navigate('Product', {item});
      }}
    >
      {/* {renderNewBadge()} */}
      {renderImage()}
      {renderInfo()}
      {renderOrderCounter()}
    </TouchableOpacity>
  );
};

export default OrderItem;
